__turbopack_context__.v({
  "fx": "hero-map-module-scss-module__i-mqlG__fx",
  "hero": "hero-map-module-scss-module__i-mqlG__hero",
  "map": "hero-map-module-scss-module__i-mqlG__map",
  "mask": "hero-map-module-scss-module__i-mqlG__mask",
});
